// import Icons from '../../components/common/icons'
import ListingHeader from '../../components/common/ListingTiles'
import { router_config } from '../../configs/route.config'
import { checkPermissions } from '../../layout/store'

const Reports = () => {
  const headerProps = {
    actionTitle: 'Add New',
    icon: 'plus',
  }
  const basicData = {
    title: 'Reports',
    // subtitle: 'View system reports from here.',
    icon: 'reports-icon',
  }

  const payrollReports = [
    {
      title: 'Fund Report',
      description: 'View and Export all Fund Data',
      page: router_config.REPORT_FUNDS.path,
      show: router_config.REPORT_FUNDS.hasAccess,
    },
    {
      title: 'Job Report',
      description: 'View and Export all Job Data',
      page: router_config.REPORT_JOBS.path,
      show: router_config.REPORT_JOBS.hasAccess,
    },
    {
      title: 'Job Query Report',
      description: 'View and Export all Job Query Data',
      page: router_config.REPORT_JOB_QUERIES.path,
      show: router_config.REPORT_JOB_QUERIES.hasAccess,
    },
    {
      title: 'Log Report',
      description: 'View and Export all Log Data',
      page: router_config.REPORT_LOGS.path,
      show: router_config.REPORT_LOGS.hasAccess,
    },
  ].filter((item) => item.show)

  return (
    <div>
      <ListingHeader
        data={basicData}
        actionProps={headerProps}
        checkPermission={checkPermissions('Employee', 'create')}
      />
      <div className="py-4 px-5">
        {/* <div className="relative mb-4">
          <input
            type="text"
            placeholder="Search by Report Name"
            className=" md:w-3/12 xl:w-2/12 rounded-md py-1.5 text-xs border-transparent outline-none border pe-5 ps-7 focus:border-primary "
          />
          <Icons
            name="search"
            className="size-4 absolute top-0 left-2 translate-y-1/2"
          />
        </div> */}
        <div className="grid gap-3 md:w-10/12 md:grid-cols-2  xl:grid-cols-3">
          {payrollReports.map((item, index) => (
            <a key={index} href={item.page}>
              <div
                key={index}
                className="bg-white rounded-md p-6 border border-formBorder min-h-[140px] flex items-center justify-center"
              >
                <div>
                  <h4 className="text-l text-blackAlt font-semibold mb-1">
                    {item.title}
                  </h4>
                  <p className="text-base text-grey-medium">
                    {item.description}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Reports
